import { Card, CardBody, Tab, TabMenu } from "@stenajs-webui/elements";
import React, { useState } from "react";
import { BookingResultData, SelectedTab } from "../types/types";
import { PriceCalculatorBookingDetailSectionalTab } from "./PriceCalculatorBookingDetailSectionalTab";
import { PriceCalculatorBookingDetailMultiLegTab } from "./PriceCalculatorBookingDetailMultiLegTab";
import { PriceCalculatorAuditTab } from "./PriceCalculatorAuditTab";
import { transformBookingResultToAuditData } from "../lib/result-panel-transformers";
import { testIdConstants } from "@/types/test-id-constants/testIdConstants";

interface Props {
  bookingResult?: BookingResultData;
}

export const PriceCalculatorBookingResultPane: React.FC<Props> = ({
  bookingResult,
}) => {
  const priceTabDisabled =
    bookingResult &&
    bookingResult.priceCalculatorData.some((data) => data.totalPrice === 0);
  const [selectedTab, setSelectedTab] = useState<SelectedTab>(
    priceTabDisabled ? SelectedTab.AUDIT : SelectedTab.PRICE
  );

  const displaySectionalDetailsTab =
    selectedTab === SelectedTab.PRICE &&
    bookingResult &&
    bookingResult.bookingData.length === 1 &&
    bookingResult.bookingData[0].movementType.code === "S";

  const displayMultiLegDetailsTab =
    selectedTab === SelectedTab.PRICE &&
    bookingResult &&
    bookingResult.bookingData.length > 0 &&
    bookingResult.bookingData[0].movementType.code === "M";

  return (
    <Card>
      <CardBody>
        <TabMenu>
          <Tab
            disabled={priceTabDisabled}
            label={"Price details"}
            selected={selectedTab === SelectedTab.PRICE}
            onClick={() => setSelectedTab(SelectedTab.PRICE)}
            data-testid={testIdConstants.priceCalculatorPriceDetailsButton}
          />
          <Tab
            label={"Audit track"}
            selected={selectedTab === SelectedTab.AUDIT}
            onClick={() => setSelectedTab(SelectedTab.AUDIT)}
            data-testid={testIdConstants.priceCalculatorAuditTrackButton}
          />
        </TabMenu>
      </CardBody>
      {bookingResult && (
        <>
          {displaySectionalDetailsTab && (
            <PriceCalculatorBookingDetailSectionalTab
              bookingResultData={bookingResult}
            />
          )}
          {displayMultiLegDetailsTab && (
            <PriceCalculatorBookingDetailMultiLegTab
              bookingResultData={bookingResult}
            />
          )}
          {selectedTab === SelectedTab.AUDIT && bookingResult && (
            <PriceCalculatorAuditTab
              auditData={bookingResult.priceCalculatorData.map((priceCalc) =>
                transformBookingResultToAuditData(
                  priceCalc,
                  bookingResult?.bookingData[0]
                )
              )}
            />
          )}
        </>
      )}
    </Card>
  );
};
